export default "__VITE_ASSET__CzF$_DX$__"